<template lang="html">
	<div class="rs-category-image">
		<img 
			:src="url" 
			class="rs-preview-image" 
			@click="show=true">
		<modal 
			:show.sync="show" 
			@hide="index=0">
			<div class="rs-gallery">
				<div class="rs-gallery-image-container">
					<img :src="currentUrl">
				</div>
				<div class="gallery-buttons">
					<button 
						@click="previous" 
						class="gallery-button"><chevron-left-icon /></button>
					<button 
						@click="next" 
						class="gallery-button"><chevron-right-icon /></button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons'
import Modal from './Modal.vue'

export default {
	name: 'CategoryImage',
	props: {
		files: Array
	},
	data() {
		return {
			show: false,
			index: 0
		}
	},
	components: {
		ChevronLeftIcon,
		ChevronRightIcon,
		Modal
	},
	methods: {
		next() {
			this.index = (this.index + 1) % this.files.length
		},
		previous() {
			this.index =
				this.index > 0 ? this.index - 1 : (this.index = this.files.length - 1)
		}
	},
	computed: {
		currentUrl() {
			const file = this.files[this.index]
			if (file) {
				return `https://${
					this.$store.state.auth.fileStorageDomain
				}/rental-system/item-categories/${file.slug}/thumbnail/${file.name}`
			}
		},
		currentType() {
			const file = this.files[this.index]
		},
		url() {
			const file = this.files.find(
				f => f.favorite && f.mimeType.includes('image')
			)
			if (file) {
				return `https://${
					this.$store.state.auth.fileStorageDomain
				}/rental-system/item-categories/${file.slug}/thumbnail/${file.name}`
			}
			return null
		}
	}
}
</script>

<style lang="css">
.rs-category-image .rs-preview-image{
    max-width: 100px;
    width: 100%;
    cursor: pointer;
}
.rs-category-image .rs-gallery-image-container{
	height: 60vh;
}
.rs-category-image .rs-gallery-image-container img{
	object-fit: contain;
	width: 100%;
	height: 100%;
}
.rs-gallery{
	width: 100%;
}
.rs-category-image .gallery-buttons{
	text-align: center;
}
.rs-category-image .gallery-buttons .gallery-button{
	outline: none;
	border: none;
	background-color: transparent;
	color: #fff;
	opacity: 0.6;
	font-size: 2em;
}
.rs-category-image .gallery-buttons .gallery-button:hover{
	opacity: 1;
}
.rs-gallery{
	text-align: center;
}
</style>
